import React from "react";
import { Document, Page, Text, View, StyleSheet,Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    fontSize: 12,
    fontFamily: "Helvetica",
    color: "#101828",
  },
  heading: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
    color: "#003149",
  },
  recordGroup: {
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    borderBottomStyle: "solid",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  label: {
    color: "#344054",
    fontWeight: "bold",
  },
  value: {
    color: "#101828",
  },
});

const ExportTasksPDF = ({ data,logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
            {logo && (
          <Image
            src={logo}
            style={{ width: 120, alignSelf: "center", marginBottom: 10 }}
          />
        )}
        <Text style={styles.heading}>
               {t("projectManagement.manageTasks")}
        </Text>

        {data.map((task, index) => (
          <View key={index} style={styles.recordGroup}>
            
            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.id")}:</Text>
              <Text style={styles.value}>{task.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.taskName")}:</Text>
              <Text style={styles.value}>{task.title}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.assigningTeam")}:</Text>
              <Text style={styles.value}>{task.assigned_by_name || "-"}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.priority")}:</Text>
              <Text style={styles.value}>{task.priority || "-"}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.createdAt")}:</Text>
              <Text style={styles.value}>{task.created_at}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.deadline")}:</Text>
              <Text style={styles.value}>{task.end_at}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("projectManagement.status")}:</Text>
              <Text style={styles.value}>{task.status}</Text>
            </View>

          </View>
        ))}
      </Page>
    </Document>
  );
};

export default ExportTasksPDF;
